import { useWeb3React } from '@web3-react/core'
import { SupportedChainId } from 'constants/chains'

import { NetworkDot, NetworkIndicatorContainer, NetworkText } from '../styleds'

type NetworkType = 'mainnet' | 'testnet' | 'devnet' | 'unknown'

function getNetworkInfo(chainId: number | undefined): { type: NetworkType; name: string } {
  switch (chainId) {
    case SupportedChainId.HYDRA:
      return { type: 'mainnet', name: 'Hydra Mainnet' }
    case SupportedChainId.TESTNET:
      return { type: 'testnet', name: 'Hydra Testnet' }
    case SupportedChainId.DEVNET:
      return { type: 'devnet', name: 'Hydra Devnet' }
    default:
      return { type: 'unknown', name: 'Unknown Network' }
  }
}

export default function NetworkIndicator() {
  const { chainId } = useWeb3React()
  const { type, name } = getNetworkInfo(chainId)

  return (
    <NetworkIndicatorContainer network={type}>
      <NetworkDot network={type} />
      <NetworkText network={type}>{name}</NetworkText>
    </NetworkIndicatorContainer>
  )
}
